// @noflow
import AxisYTicks from './yTicks';
import PropTypes from 'prop-types';
import * as React from 'react';

export default function AxisY({ barChartData, compHeight, axisStyles, margin, yDomain, yTicksInterval }) {
    const lineStyle = { stroke: axisStyles.axisColour };
    const y2 = compHeight - margin.bottom;

    return (
        <g>
            <line name="yAxis" style={lineStyle} x1={margin.left} x2={margin.left} y1={margin.top} y2={y2} />
            <AxisYTicks
                axisStyles={axisStyles}
                barChartData={barChartData}
                compHeight={compHeight}
                margin={margin}
                yDomain={yDomain}
                yTicksInterval={yTicksInterval}
            />
        </g>
    );
}

AxisY.propTypes = {
    axisStyles: PropTypes.shape({
        axisColour: PropTypes.string.isRequired,
        fontColour: PropTypes.string.isRequired,
        fontFamily: PropTypes.string.isRequired,
        fontSize: PropTypes.string.isRequired
    }),
    barChartData: PropTypes.arrayOf(
        PropTypes.shape({
            labelX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            width: PropTypes.number.isRequired,
            x: PropTypes.number.isRequired
        })
    ).isRequired,
    compHeight: PropTypes.number.isRequired,
    margin: PropTypes.shape({
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired,
        bottom: PropTypes.number.isRequired,
        right: PropTypes.number.isRequired
    }),
    yDomain: PropTypes.string.isRequired,
    yTicksInterval: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/graph/axis/axisY/index.js